import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { fetchSimilar } from "../lib/api";
import ProductCard from "./ProductCard";

export default function SimilarProducts({ category, excludeId }) {
  const [items, setItems] = useState([]);
  useEffect(() => {
    let alive = true;
    fetchSimilar(category, excludeId).then((d) => { if (alive) setItems(d); }).catch(() => {});
    return () => { alive = false; };
  }, [category, excludeId]);

  if (items.length === 0) return null;

  return (
    <section className="mt-section pt-6" data-testid="similar-products">
      <div className="mt-container">
        <div className="flex items-end justify-between mb-10 mt-enter">
          <h2 className="font-display font-extralight leading-[1.08] text-[clamp(2rem,5vw,4rem)]">
            You Might Also <span className="italic mt-chrome-text mt-keep-anim">Like</span>
          </h2>
          <Link to="/shop" className="mt-nav-link hidden sm:inline-flex">View All &nbsp;→</Link>
        </div>
        <div className="mt-hscroll" data-testid="similar-scroll">
          {items.map((p, i) => (
            <div key={p.id} className="w-[min(360px,82vw)]">
              <ProductCard product={p} index={i} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
